module.exports = __webpack_public_path__ + "img/142.d9d380e6.png";